import { deepOrange, grey } from "@mui/material/colors";

export const dark = {
	primary: {
		main: "#5D87FF",
		light: "#253662",
		dark: "#4570EA",
		contrastText: "#ffffff",
	},
	secondary: {
		main: "#49BEFF",
		light: "#1C455D",
		dark: "#23afdb",
		contrastText: "#ffffff",
	},
	background: {
		default: "#2A3447",
		dark: "#2A3547",
		paper: "#2A3447",
	},
	error: {
		main: "#F87171",
		light: "#3F2937",
		dark: "#EF4444",
		contrastText: "#ffffff",
	},
	warning: {
		main: "#FBBF24",
		light: "#451A03",
		dark: "#F59E0B",
		contrastText: "#000000",
	},
	success: {
		main: "#34D399",
		light: "#064E3B",
		dark: "#10B981",
		contrastText: "#000000",
	},
	info: {
		main: "#60A5FA",
		light: "#1E3A8A",
		dark: "#3B82F6",
		contrastText: "#ffffff",
	},
	progress: {
		main: deepOrange[200],
		light: "#451A03",
		dark: deepOrange[200],
		contrastText: "#ffffff",
	},
	default: {
		main: "#9CA3AF",
		light: "#374151",
		dark: "#6B7280",
		contrastText: "#ffffff",
	},
	divider: grey[800],
};
